import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Copy, Download, Save } from "lucide-react";

export function AnswersPanel({ answers, saving, saveSet, currentSetId, downloadAll, updateAnswer, copyOne }) {
  return (
    <div className="space-y-4" data-testid="screening-output">
      <div className="flex justify-end gap-2">
        <Button onClick={saveSet} disabled={saving} data-testid="save-set-button" className="active:scale-[0.98] transition-transform">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="h-4 w-4 mr-1.5" strokeWidth={1.5} /> {currentSetId ? "Update Set" : "Save Set"}</>}
        </Button>
        <Button variant="outline" onClick={downloadAll} data-testid="download-answers-button"><Download className="h-4 w-4 mr-1.5" strokeWidth={1.5} /> Download All</Button>
      </div>
      {answers.map((a, i) => (
        <Card key={a._k || i} className="border-zinc-200 shadow-sm" data-testid={`answer-card-${i}`}>
          <CardHeader className="pb-3 flex flex-row items-start justify-between gap-3 space-y-0">
            <CardTitle className="font-heading text-base leading-snug">{a.question}</CardTitle>
            <Button variant="ghost" size="icon" className="h-8 w-8 shrink-0" onClick={() => copyOne(a.answer)} data-testid={`copy-answer-${i}`}>
              <Copy className="h-4 w-4" strokeWidth={1.5} />
            </Button>
          </CardHeader>
          <CardContent>
            <Textarea rows={5} value={a.answer} onChange={(e) => updateAnswer(i, e.target.value)} data-testid={`answer-text-${i}`} />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
